import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { CONTACT } from "../utils/contact";
import maskanhLogo from "../assets/logo.png";
import WhatsAppIcon from "./WhatsAppIcon";
import DarkModeToggle from "./DarkModeToggle";
import "./Navbar.css";

const NAV_LINKS = [
  { label: "Services", href: "/#services" },
  { label: "Team", href: "/#team" },
  { label: "Contact", href: "/#contact" },
];

const MOBILE_EXTRA = [
  { label: "Why Us", href: "/#why-us" },
  { label: "Book Now", href: "/#request-form" },
  { label: "Blogs", href: CONTACT.blogs, isRoute: true },
  { label: "Privacy Policy", href: CONTACT.privacyPolicy, isRoute: true },
  { label: "Terms & Conditions", href: CONTACT.terms, isRoute: true },
];

function MobileMenuLinks({ onClose }) {
  return (
    <>
      <nav className="navbar-mobile-nav">
        {NAV_LINKS.map((link) => (
          <a key={link.href} href={link.href} onClick={onClose}>
            {link.label}
          </a>
        ))}
      </nav>

      <a
        href={CONTACT.whatsappUrl}
        className="navbar-mobile-wa"
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClose}
      >
        <span className="navbar-wa-icon">
          <WhatsAppIcon />
        </span>
        Chat on WhatsApp
      </a>

      <div className="navbar-mobile-extra">
        {MOBILE_EXTRA.map((link) =>
          link.isRoute ? (
            <Link key={link.href} to={link.href} onClick={onClose}>
              {link.label}
            </Link>
          ) : (
            <a key={link.href} href={link.href} onClick={onClose}>
              {link.label}
            </a>
          )
        )}
      </div>
    </>
  );
}

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const closeMenu = () => setOpen(false);

  useEffect(() => {
    if (!open) return undefined;

    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const mobileMenu =
    open &&
    createPortal(
      <div className="navbar-mobile-layer" role="presentation">
        <button
          type="button"
          className="navbar-mobile-backdrop"
          aria-label="Close menu"
          onClick={closeMenu}
        />
        <aside className="navbar-mobile-panel" aria-label="Mobile navigation">
          <div className="navbar-mobile-panel-head">
            <span>Menu</span>
            <button
              type="button"
              className="navbar-mobile-close"
              aria-label="Close menu"
              onClick={closeMenu}
            >
              ×
            </button>
          </div>
          <MobileMenuLinks onClose={closeMenu} />
        </aside>
      </div>,
      document.body
    );

  return (
    <header className="navbar">
      <div className="container navbar-inner">
        <Link to="/" className="navbar-brand" onClick={closeMenu}>
          <img src={maskanhLogo} alt="Maskanh" className="navbar-logo" />
          <span className="navbar-brand-text">Maskanh</span>
        </Link>

        <div className="navbar-menu navbar-menu--desktop">
          <nav className="navbar-center">
            {NAV_LINKS.map((link) => (
              <a key={link.href} href={link.href}>
                {link.label}
              </a>
            ))}
          </nav>

          <div className="navbar-actions">
            <a
              href={CONTACT.whatsappUrl}
              className="navbar-wa"
              target="_blank"
              rel="noopener noreferrer"
              title="Chat on WhatsApp"
              aria-label="WhatsApp"
            >
              <span className="navbar-wa-icon">
                <WhatsAppIcon />
              </span>
              <span className="navbar-wa-text">WhatsApp</span>
            </a>
          </div>
        </div>

        <div className="navbar-end">
          <DarkModeToggle />
          <button
            type="button"
            className={`navbar-toggle ${open ? "active" : ""}`}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            onClick={() => setOpen(!open)}
          >
            <span className="navbar-bar" />
            <span className="navbar-bar" />
            <span className="navbar-bar" />
          </button>
        </div>
      </div>

      {mobileMenu}
    </header>
  );
}
